/** Lib Imports */
import React from "react";
import PropTypes from 'prop-types';

/** Phone Input Lib */
import { PhoneInput, parseCountry, defaultCountries } from "react-international-phone";

/** CSS */
import 'react-international-phone/style.css';

const countries = defaultCountries.filter((country) => {
  const { iso2 } = parseCountry(country);
  return ['in'].includes(iso2);
});

const PhoneField = ({
  value,
  onChange,
  onBlur,
}) => {

  const formatPhoneValue = (value) => {
    if (!value) return "";
  
    if (value.startsWith("+")) return value;
  
    return `+91${value}`;
  };
  
  return (

    <div className="p-field">
      <PhoneInput
        defaultCountry="in"
        countries={countries}
        value={formatPhoneValue(value) || ""}
        onBlur={onBlur}
        forceDialCode={true}
        onChange={(phone) => onChange(phone)}
        hideDropdown
        style={{ width: "100%" }}
      />
    </div>
  );
};

PhoneField.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
};

export default PhoneField;
